import React, { Component } from 'react';
import Currency from '../../../commonModules/Currency';
import PopUp from '../../../commonModules/interface/PopUp';
import { Button, Table, TableBody, TableRow, Typography } from '@material-ui/core';
import { TableLayout } from '../Stock/containers/Layout';
import InputText, { TextArea } from '../../../commonModules/interface/form-input-inline.jsx';

class SupressPayment extends Component {
    state = { 
        errors: {
            code:"",
            note:"",
        },
        note:"",
        code:"",
    }
    sendSupress = async () =>{
        console.log("[INFO], sendSupress")
        if (this.state.code.length < 5){
            this.setState({errors:{
                code:"Code can not be empty",
                note:"",
            }})
            return
        }
        if(this.state.note.length < 10){
            this.setState({errors:{
                code:"",
                note:"Not must be longer",
            }})
            return
        }
        try {
            let data = {
                action:"supress_payment",
                code:this.state.code,
                note:this.state.note,
                paymentid: this.props.deletePaymentInfo.id,
                amount: this.props.deletePaymentInfo.money,
            }
            const response = await fetch('/payment/supress/payment', {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              json: true,
              body: JSON.stringify(data),
              credentials: 'same-origin'
            });
            const resp = await response.json();
            console.log(resp);
            if (resp.content !== "OK") {
                this.setState({errors:{
                    code:"",
                    note:resp.content,
                }})
              console.log("[ERROR], getting schema getAll response ", resp)
              return;
            }
            this.props.close()
        } catch (err) {
            console.log("[ERROR], error", err)
            this.setState({errors:{
                code:"",
                note:"Internal error",
            }})
        }

    }
    handleChange = (e) => { 
        const { name, value } = e.target
        this.setState({
            ...this.state,
            [name] : value,
        })
    }
    render() {
        const { userInfo, deletePaymentInfo} = this.props;
        console.log('====================================');
        console.log(this.props);
        console.log('====================================');
        return (
            <PopUp 
                close={this.props.close}
                title={`Supression Paiement de ${deletePaymentInfo.money}`}
                submitAction={this.sendSupress}
                submitTitle="Confirmer Supression"
                maxWidth="md"
            >   
                {/* <Typography variant="h4" component="h1" gutterBottom>
                Supression Paiement de {deletePaymentInfo.money} 
                </Typography>              */}
                <InputText type="text" id="code" change={this.handleChange} value={this.state.code} error={this.state.errors.code} name="code" placeholder="Code supression"/>
                <TextArea id="note" change={this.handleChange} value={this.state.note} error={this.state.errors.note} name="note" placeholder="Note sur la raison de la supression"  rows={5}/>
                {/* <Button color="secondary" onClick={ () => this.sendSupress()} >Confirmer Supression</Button> */}
            </PopUp>
        );
    }
}

export default SupressPayment;